import { render, staticRenderFns } from "./ParticipantHeader.vue?vue&type=template&id=e339b324"
import script from "./ParticipantHeader.vue?vue&type=script&lang=ts"
export * from "./ParticipantHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports